import { createSelectorHook } from 'react-redux';
import { IState } from '.';

export const useSelector = createSelectorHook<IState>()


// WEBPACK FOOTER //
// ./src/redux/useSelector.ts